<!-- TODO:　最低限しか実装していないので、必要に応じて追加してください。 -->
<script lang="ts" setup>
import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { computed, onMounted, ref } from 'vue';
import Btn from '@/components/input/Btn/SimpleClickBtn.vue';
import router from '@/router';

// style variables
const TitleWrapper = styled.h2`
  font-size: 3.75rem; /* 60px */
  line-height: 1;
  margin-top: 6rem; /* 128px */
`;

const ContentWrapper = styled.div`
  width: 77%
  margin-top: 3rem; /* 48px */
`;

const TextWrapper = styled.p`
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
`;

const InstructionsWrapper = styled.div`
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
  margin-top: 1rem;
`;

//変数
const t = i18n.t;

//関数
/**
 * ホーム画面に遷移する
 */
const returnHomePage = (): void => {
  router.push('/');
};
</script>

<template>
  <TitleWrapper class="text-center font-bold">{{ t('404 Not Found') }}</TitleWrapper>
  <ContentWrapper class="mx-auto">
    <TextWrapper class="text-center">
      {{ t('お探しのページが見つかりませんでした。お手数ですが、ホーム画面から再度アクセスしてください。') }}
    </TextWrapper>
    <InstructionsWrapper class="text-center">
      <Btn :label-text="`>> ${t('ホームに戻る')}`" :page-address="'/'" @click="returnHomePage" />
    </InstructionsWrapper>
  </ContentWrapper>
</template>

<style lang="scss" scoped />
